import { Components, Theme } from '@mui/material';
import { alpha } from '@mui/material/styles';
import type { palette as themePalette } from '~/shared/styles/theme/palette';

const BORDER_RADIUS_PILL = 9999;

export const MuiButton: Components<Theme>['MuiButton'] = {
  styleOverrides: {
    root: {
      textTransform: 'none',
      borderRadius: BORDER_RADIUS_PILL,
    },
  },
  variants: [
    {
      props: { variant: 'contained' },
      style: ({ theme }) => {
        const palette = theme.palette as unknown as typeof themePalette;
        return {
          color: theme.palette.common.white,
          backgroundColor: palette.amount.main,
          width: '100%',
          textAlign: 'center',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontWeight: 700,
          fontSize: 18,
          boxShadow: 'none',

          '&:hover': {
            boxShadow: 'none',
            backgroundColor: palette.amount.dark,
          },

          '&:disabled': {
            cursor: 'not-allowed',
          },
        };
      },
    },
    {
      props: { variant: 'outlined' },
      style: ({ theme }) => {
        const palette = theme.palette as unknown as typeof themePalette;
        return {
          borderColor: palette.amount.main,
          color: palette.amount.main,
          '&:hover': {
            borderColor: palette.amount.dark,
            color: palette.amount.dark,
            backgroundColor: alpha(palette.amount.main, 0.04),
          },
        };
      },
    },
  ],
};
